import React from 'react';
import './Pages.css';

export default function Services() {
  return (
    <main className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive solutions tailored to meet your unique needs</p>
        </div>
      </section>

      <section className="container page-section">
        <div className="services-grid">
          <div className="service-card">
            <h3>🌐 Web Development</h3>
            <p>Custom web applications built with modern technologies and best practices.</p>
            <ul>
              <li>Responsive Design</li>
              <li>SEO Optimized</li>
              <li>Fast Performance</li>
              <li>Secure & Scalable</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>📱 Mobile Development</h3>
            <p>Native and cross-platform mobile applications for iOS and Android.</p>
            <ul>
              <li>Native Apps</li>
              <li>Cross-Platform</li>
              <li>App Store Ready</li>
              <li>Push Notifications</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>🎨 UI/UX Design</h3>
            <p>Beautiful and intuitive user interfaces for optimal user experience.</p>
            <ul>
              <li>User Research</li>
              <li>Wireframing</li>
              <li>Prototyping</li>
              <li>Design Systems</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>☁️ Cloud Solutions</h3>
            <p>Scalable cloud infrastructure and migration services.</p>
            <ul>
              <li>Cloud Migration</li>
              <li>Infrastructure</li>
              <li>DevOps</li>
              <li>Monitoring</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>⚙️ API Development</h3>
            <p>RESTful and GraphQL APIs for seamless integration.</p>
            <ul>
              <li>RESTful APIs</li>
              <li>GraphQL</li>
              <li>Documentation</li>
              <li>Testing</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>💼 Consulting</h3>
            <p>Strategic technology consulting aligned with business goals.</p>
            <ul>
              <li>Strategy</li>
              <li>Architecture</li>
              <li>Best Practices</li>
              <li>Training</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="values-section">
        <div className="container">
          <h2>Our Process</h2>
          <div className="process-grid">
            <div className="process-step">
              <div className="step-number">01</div>
              <h3>Discovery</h3>
              <p>Understand your needs and goals</p>
            </div>
            <div className="process-step">
              <div className="step-number">02</div>
              <h3>Planning</h3>
              <p>Create a detailed project roadmap</p>
            </div>
            <div className="process-step">
              <div className="step-number">03</div>
              <h3>Development</h3>
              <p>Build with quality and precision</p>
            </div>
            <div className="process-step">
              <div className="step-number">04</div>
              <h3>Delivery</h3>
              <p>Launch and provide ongoing support</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
